// Toast configuration for consistent styling
export const toastConfig = {
  position: "top-center",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: "light",
};

// Accent colors derived from $blue: #0cb8b6
// We use a darker shade for the dashboard-like sophisticated look requested.

// Success toast configuration - Dark Teal/Green
export const successToastConfig = {
  ...toastConfig,
  style: {
    background: '#0a9694', // Darker shade of #0cb8b6
    color: '#fff',
    fontWeight: '500',
    borderRadius: '8px',
    boxShadow: '0 4px 12px rgba(10, 150, 148, 0.4)',
    border: '1px solid #087a79',
  },
  progressStyle: {
    background: '#065c5b',
  }
};

// Error toast configuration - Dark Red/Orange (consistent with palette but distinct)
export const errorToastConfig = {
  ...toastConfig,
  style: {
    background: '#e6492d', // Using the $red variable value
    color: '#fff',
    fontWeight: '500',
    borderRadius: '8px',
    boxShadow: '0 4px 12px rgba(230, 73, 45, 0.4)',
    border: '1px solid #c93b21',
  },
  progressStyle: {
    background: '#9e2e1a',
  }
};

// Warning toast configuration
export const warningToastConfig = {
  ...toastConfig,
  style: {
    background: '#f6ab2f', // Using $orange
    color: '#fff', // White text for better contrast on this orange
    fontWeight: '500',
    borderRadius: '8px',
    boxShadow: '0 4px 12px rgba(246, 171, 47, 0.4)',
    border: '1px solid #d9911e',
  },
  progressStyle: {
    background: '#bf7d15',
  }
};

// Info toast configuration
export const infoToastConfig = {
  ...toastConfig,
  style: {
    background: '#27b1d9', // Using $light-blue
    color: '#fff',
    fontWeight: '500',
    borderRadius: '8px',
    boxShadow: '0 4px 12px rgba(39, 177, 217, 0.4)',
    border: '1px solid #1f94b5',
  },
  progressStyle: {
    background: '#166e87',
  }
};
